export const GET_PRODUCT_LIST_SUCCESS = 'GET_PRODUCT_LIST_SUCCESS';
export const GET_PRODUCT_LIST_FAIL = 'GET_PRODUCT_LIST_FAIL';

export const GET_PRODUCT_DETAIL_SUCCESS = 'GET_PRODUCT_DETAIL_SUCCESS';
export const GET_PRODUCT_DETAIL_FAIL = 'GET_PRODUCT_DETAIL_FAIL';

export const GET_IMAGE_PRODUCT_SUCCESS = 'GET_IMAGE_PRODUCT_SUCCESS';
export const GET_IMAGE_PRODUCT_FAIL = 'GET_PRODUCT_FAIL';